import React from 'react';
import { InformationPad, Link } from '../../../components/shared';
import { routeConstants } from '../../../constants/routeConstants';
import { Box, Tooltip } from '@mui/material';
import useStyles from './style';
import { LEASE_DETAILS } from '../../../constants/accordionFields';
import { getDateFormat } from '../../../utils/common-methods';
import { rentDetailsFields } from '../../../constants/rentDetailsConfig';

const LeaseDetailsAccordion = (props) => {
  const { LEASE, RENT } = LEASE_DETAILS;
  const classes = useStyles();
  const { leaseDetails, isFrom = 'LEASE' } = props;

  const locationLink = (id, name) => (
    <Link underline="none" to={`/${routeConstants.LOCATION_ROUTE}/${id}`}>
      {name}
    </Link>
  );

  const sublocationLink = (id, name, locationId, isLast) => (
    <Link underline="none" to={`/${routeConstants.SUBLOCATION_ROUTE}/${id}?locationId=${locationId} `} key={id}>
      {`${name}${isLast ? '' : ', '}`}
    </Link>
  );

  const contractLinkValue = leaseDetails?.contractLink || '';
  let isNavigableLink = false;

  try {
    const url = new URL(contractLinkValue);
    isNavigableLink = url.protocol === 'http:' || url.protocol === 'https:';
  } catch (e) {
    isNavigableLink = false;
  }
  const contractLinkDisplay = isNavigableLink ? (
    <Tooltip
      title={contractLinkValue}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'white',
            color: 'black',
            border: '1px solid #e0e0e0',
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
            fontSize: '12px',
            p: 1,
          },
        },
      }}
    >
      <a href={contractLinkValue} target="_blank" rel="noopener noreferrer" className={classes.contractLink}>
        {contractLinkValue}
      </a>
    </Tooltip>
  ) : (
    <span className={classes.contractLink} style={{ cursor: 'default', textDecoration: 'none', color: 'inherit' }}>
      {contractLinkValue}
    </span>
  );
  const leaseDetailsFields = [
    {
      label: LEASE.LOCATION,
      value: locationLink(leaseDetails?.location?.id, leaseDetails?.location?.locationName),
    },
    {
      label: LEASE.SUB_LOCATION,
      value: leaseDetails?.contractSublocations?.map((item, index) =>
        sublocationLink(
          item?.sublocation?.id,
          item?.sublocation?.name,
          leaseDetails?.location?.id,
          index + 1 === leaseDetails?.contractSublocations?.length,
        ),
      ),
    },
    { label: LEASE.ADDRESS1, value: leaseDetails?.location?.address1 },
    { label: LEASE.ADDRESS2, value: leaseDetails?.location?.address2 },
    { label: LEASE.ZIPCODE, value: leaseDetails?.location?.postcode },
    { label: LEASE.COUNTRY, value: leaseDetails?.location?.country?.name },
    { label: LEASE.STATE, value: leaseDetails?.location?.state?.name },
    { label: LEASE.CITY, value: leaseDetails?.location?.city?.name },
    { label: LEASE.BOOTH_INFO, value: 'N/A' },
    {
      label: LEASE.SPACE,
      value:
        leaseDetails?.contractSublocations
          ?.map((cs) => cs.sublocation?.spaceIdentifier)
          .filter(Boolean)
          .join(', ') || 'N/A',
    },
    { label: LEASE.DBA, value: 'N/A' },
    { label: LEASE.TYPE, value: leaseDetails?.leaseType },
    { label: LEASE.STATUS, value: leaseDetails?.leaseStatus },
    {
      label: LEASE.LEASE_BEGINS,
      value: getDateFormat(leaseDetails?.termStartDate),
    },
    {
      label: LEASE.LEASE_ENDS,
      value: getDateFormat(leaseDetails?.termEndDate),
    },
    {
      label: RENT.CONTRACT_Link,
      value: contractLinkDisplay,
    },
  ];

  const showingFieldsData = (from) => {
    switch (from) {
      case 'LEASE': {
        const rentFields = rentDetailsFields(leaseDetails?.rentType, leaseDetails).filter(
          (field) => field.label !== RENT.CONTRACT_Link,
        );
        return [...leaseDetailsFields, ...rentFields];
      }
      default:
        return [];
    }
  };

  return (
    <Box className={classes.leaseDetailsAccordion}>
      <InformationPad
        data={showingFieldsData(isFrom)}
        headingColumn={{ xs: 12, sm: 4, lg: 2.25 }}
        titleColumn={{ xs: 12, sm: 8, lg: 9.75 }}
      />
    </Box>
  );
};

export default LeaseDetailsAccordion;
